import { debounce } from 'lodash-es'

/**
 * 固定宽高比，计算缩放比例
 * @param {Number} width 宽度
 * @param {Number} height 高度
 * @param {String} background 超出部分显示的背景色
 * @returns
 */
export const setScale = (width, height, background) => {
  const getScale = () => {
    const wh = document.documentElement.clientHeight / height
    const ww = document.documentElement.clientWidth / width
    return ww < wh ? ww : wh
  }
  const set = () => {
    document.getElementById(
      'root'
    ).style = `transform: scale(${getScale()}) translate(-50%, -50%);
          display: flex;
          flex-direction: column;
          transform-origin: 0 0;
          left: 50%;
          top: 50%;
          transition: 0.3s;
          z-index: 999;
          position: absolute;`
  }

  document.body.style = `background:${background}`
  set()
  window.addEventListener('resize', debounce(set, 500, { leading: false }))
}
